// vue-router query values can be a string, null, or an array of either
// (e.g. "?code=A&code=B"). Normalize to a single string everywhere we
// read a query param that we're about to hand to an API or a URL.
function toQueryString(value, fallback = "") {
  if (Array.isArray(value)) {
    return value.find((entry) => typeof entry === "string") ?? fallback;
  }
  return typeof value === "string" ? value : fallback;
}

export default toQueryString;
